<template>
  <div class="input-buscar">
    <CustomIcon :icon="lupaIcon" size="16px" class="input-buscar-icon text-primary" />
    <input
      :value="modelValue"
      type="text"
      class="input-buscar-field text-primary"
      :placeholder="placeholder"
      @input="emit('update:modelValue', $event.target.value)" />
    <MyGocuButton
      v-if="modelValue"
      tertiary
      class="flex-shrink-0"
      :prefix-icon="cerrarIcon"
      @click="emit('update:modelValue', '')" />
  </div>
</template>

<script setup>
  import CustomIcon from 'src/components/CustomIcon.vue';
  import MyGocuButton from 'src/components/common/buttons/MyGocuButton.vue';
  import lupaIcon from 'src/assets/icons/raw/lupa.svg';
  import cerrarIcon from 'src/assets/icons/raw/cerrar.svg';

  defineProps({
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  });

  const emit = defineEmits(['update:modelValue']);
</script>

<style lang="scss" scoped>
  .input-buscar {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    padding: 0 10px;
    border-radius: 6px;
    background-color: rgba(var(--bs-primary-rgb), 0.02);
    box-shadow: 0 0 3px 0 rgba(var(--bs-primary-rgb), 0.3) inset;
  }

  .input-buscar-icon {
    flex-shrink: 0;
    opacity: 0.5;
  }

  .input-buscar-field {
    flex: 1;
    min-width: 0;
    height: 100%;
    border: none;
    outline: none;
    background: transparent;
    padding: 0;
    margin: 0;
    font-size: 16px;
    line-height: normal;
    text-align: left;

    &::placeholder {
      color: var(--bs-primary);
      opacity: 0.45;
      text-align: left;
    }
  }
</style>
